import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { Station } from '../interfaces/station';

@Injectable({
  providedIn: 'root'
})
export class StationsService {

  public stations: Array<Station> = [];
  public stationCount: number = 0;
  public maxPages: number = 1;
  public pageSize: number = 6;

  constructor(
    private api: RestApiService
  ) { }

  getStation(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/station/' + id, {}, true).then((res) => {
        resolve(res);
      });
    });
  };

  deleteStation(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.delete(`/MI_Galago/WCF_MI_Galago/REST/vop/station/${id}`).then((res) => {
        resolve(res);
      });
    });
  };

  updateStationCount(search?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let query: any = {};

      if (typeof search === 'string' && search.length > 0) {
        query.search = search;
      }
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetStationsVOPCount', query, true).then((res) => {
        this.stationCount = res;
        this.maxPages = Math.ceil(res / this.pageSize);
        if (res <= this.pageSize) {
          this.maxPages = 0;
        }
        resolve(res);
      });
    });
  }

  getStationCount(): number {
    return this.stationCount;
  };

  getStationMaxPages(): number {
    return this.maxPages;
  }

  setStations(stations): void {
    this.stations = stations;
  };

  getStations(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetStationsVOP', {}, false).then((res) => {
        if (typeof res === 'object' && res.length > 0) {
          this.setStations(res);
        }
        resolve(res);
      });
    });
  };

  updateStation(station): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.put(`/MI_Galago/WCF_MI_Galago/REST/vop/station`, {
        station: station
      }, false).then((res) => {
        resolve(res);
      });
    });
  }

  updateStations(page, search?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let query: any = {
        page: page,
        pageSize: this.pageSize,
        column: 1,
        sortType: 1
      };

      if (typeof search === 'string' && search.length > 0) {
        query.search = search;
      }

      this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetStationsVOP', query, true).then((res) => {
        if (typeof res === 'object' && res.length > 0) {
          this.setStations(res);
        }
        resolve(res);
      });
    });
  }

  getStationVehicles(idStation: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get(`/MI_Galago/WCF_MI_Galago/REST/vop/station/${idStation}/vehicles`, {}, true).then((res) => {
        resolve(res);
      });
    });
  }

  updateStationVehicles(idStation: number, vehicleList: Array<number>): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.post(`/MI_Galago/WCF_MI_Galago/REST/vop/station/${idStation}/vehicles`, {
        vehicles: vehicleList
      }, false).then((res) => {
        resolve(res);
      });
    });
  }

  addStation(station: {
    name: string,
    address?: string,
    zipCode?: string,
    city?: string,
    latitude?: any,
    longitude?: any,
    idSocietyVop?: number
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.post('/MI_Galago/WCF_MI_Galago/REST/vop/station', {
        station: station
      }, false).then((res) => {
        resolve(res);
      });
    });
  }
}
